<template>
  <div class="flex justify-center w-full h-full">
    <div class="marvel-device" :class="device">
      <div class="speaker"></div>
      <div class="screen">
        <IframeComponent
          v-if="html"
          :html="html"
          style="width: 100%; border: none; height: 100%"
        />
        <UISpin v-else />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { UISpin } from '@gohighlevel/ghl-ui'
import IframeComponent from 'common/components/Preview/IframeComponent.vue'

const props = defineProps({
  html: {
    type: String,
    default: '',
  },
  device: {
    type: String,
    default: 'mobile',
  },
})
</script>

<style>
.marvel-device,
.marvel-device div,
::before,
::after {
  -webkit-transition: all 500ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition: all 500ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
</style>
